/* eslint no-unused-vars: 'off', operator-linebreak: off */
import metricsHelper from '@/scripts/metricsHelper';
import current from '@/scripts/current';
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import store from '@/store';
import crypto from 'crypto';
//import { uuid } from "vue-uuid";
import { v4 as uuidv4 } from "uuid";

export default {
    //generateUUID,
    startAnalysis: function () {
        triggerOmnitureInteractions(current.currentType.toUpperCase());
    },
    yearSelected: function () {
        metricsHelper.trigger([getYearType()]);
    },
    locationSelected: function () {
        metricsHelper.trigger([getLocationType()]);
    },
    reportRequested: function () {
        metricsHelper.trigger(['VW', ...getOmnitureInteraction()]);
    },
    reportLoaded: function () {
        metricsHelper.trigger(['VW', 'Loaded']);
    },
    reportFailed: function () {
        metricsHelper.trigger(['VW', 'Failed']);
    },
    serverError: function () {
        metricsHelper.trigger(['VW', 'ServerError']);
    },
    reportLoadCached: function () {
        metricsHelper.trigger(['VW', 'LoadCached']);
    },
    reportDownloaded: function () {
        metricsHelper.trigger(['VW', 'Downloaded']);
    },
    reportPrinted: function () {
        metricsHelper.trigger(['VW', 'Printed']);
    },
    reset: function () {
        metricsHelper.trigger(['VW', 'Reset', current.selectionModel.currentStep]);
    },
    back: function () {
        metricsHelper.trigger(['VW', 'Back', current.selectionModel.currentStep]);
    },
    trigger: function (parms) {
        triggerOmnitureInteractions([current.currentType.toUpperCase(), ...parms].join(','));
    },
    test: function () {
        //console.log('tester');
        //current.initializeCrossTabulationValues(vm);
        //metricsHelper.startAnalysis();
        //metricsHelper.yearSelected();
        //metricsHelper.locationSelected();
        //metricsHelper.reportRequested();
        //metricsHelper.reportLoaded();
        //metricsHelper.reportFailed();
        //metricsHelper.reportLoadCached();
        //metricsHelper.reportDownloaded();
        //metricsHelper.reportPrinted();
        //metricsHelper.reset();
        //metricsHelper.back();
        //console.log(minimize([1, 2, 3, 5, 6, 7], 30))
        //console.log(minimize([1, 3, 5, 7], 30))
        //console.log(minimize([1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 15, 17, 19, 21, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 15, 17, 19, 21, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 15, 17, 19, 21, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 15, 17, 19, 21], 30))
    }
}

var omnitureInteractionsUrl = process.env.VUE_APP_OMNITURE + '?cl=session&j=1.0&c41=DPH BRFSS WEAT&c40=[c40]&i=[i]';

function getYearType() {
    switch (store.state.selModel.years.selectionType) {
        case 'single':
            return 'SingleYear';
        case 'combine':
            return 'CombineYears';
        case 'compare':
            return 'CompareYears';
        default:
            return 'SingleYear';
    }
}

function getLocationType() {
    switch (store.state.selModel.locations.selectionType) {
        case 'single':
            return 'SingleLocation';
        case 'combine':
            return 'CombineLocations';
        case 'compare':
            return 'CompareLocations';
        default:
            return 'SingleLocation';
    }
}

function generateUUID() {
    return uuidv4();
    // var results = generateUUID2();
    // console.log('generateUUID', results, uuid.v4(), uuidv4());
    // return results;
}

// function generateUUID2() { // Public Domain/MIT
//     var d = new Date().getTime();//Timestamp
//     var d2 = (performance && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
//     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
//         var r = Math.random() * 16;//random number between 0 and 16
//         //var crypto = window.crypto || window.msCrypto; 
//         //var r = crypto.randomInt(0, 16);
//         //console.log('crypto', r, rOld);

//         // var random_num = new Uint8Array(2048 / 8); // 2048 = number length in bits
//         // // window.crypto.getRandomValues(random_num);
        
//         // crypto.getRandomValues(random_num);

        

//         if (d > 0) { //Use timestamp until depleted
//             r = (d + r) % 16 | 0;
//             d = Math.floor(d / 16);
//         } else { //Use microseconds since page-load if supported
//             r = (d2 + r) % 16 | 0;
//             d2 = Math.floor(d2 / 16);
//         }
//         return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
//     });
// }

var locationIdSkips = [3, 7, 14, 15, 43, 52, 57, 58, 59, 60, 61, 62, 63, 64, 65, 67, 68, 69, 70, 71, 73, 74, 75, 76, 77];
function getOmnitureInteraction() {
    return [
        minimize(store.state.selModel.years.values, 30, []),
        minimize(store.state.selModel.locations.ids, 30, locationIdSkips),
        variableSelectionHelper.getAllSelectedVariableNames().join(',')];
}

function minimize(values, limit, skip) {
    var results = [];
    var listStart = null;
    var listEnd = null;
    for (var i = 0; i < values.length; ++i) {
        if (listStart === null) {
            listStart = values[i];
            listEnd = listStart;
        } else {
            //3, 7, 14, 15
            //15
            var previousN = values[i] - 1;
            //console.log('here', previousN, skip)
            while (previousN > listEnd && skip.indexOf(previousN) >= 0) {
                previousN--;
            }
            if (previousN === listEnd) {
                listEnd = values[i];
            } else {
                writeListItems(results, listStart, listEnd);
                listStart = values[i];
                listEnd = listStart;
            }
        }
    }
    writeListItems(results, listStart, listEnd)
    var totalLength = 0;
    for (i = 0; i < results.length; ++i) {
        totalLength = totalLength + results[i].length + 1;
        if (totalLength > limit) {
            //We have reached the total limit of the string
            if (i === 0)
                return '>';
            else
                return results.slice(0, i).join(',') + '>';
        }
    }
    //The lis tis not too long
    return results.join(',');
}

function writeListItems(results, listStart, listEnd) {
    if (listStart === null)
        return;
    if (listStart === listEnd) {
        results.push(listStart.toString());
    } else if (listEnd === listStart + 1) {
        results.push(listStart.toString())
        results.push(listEnd.toString())
    } else {
        results.push(listStart.toString() + '-' + listEnd.toString());
    }
}
function truncateList(list, length) {
    if (list.length <= length)
        return list;
    var lastComma = list.lastIndexOf(',');
    if (lastComma < 1)
        return '';
    return list.substring(0, lastComma) + '>';
}

function triggerOmnitureInteractions(interactionData) {
    //console.log(interactionData);
    var url = encodeURI(omnitureInteractionsUrl.replace('[c40]', 'DPH BRFSS WEAT,' + interactionData).replace('[i]',  generateUUID()).replace('islCategory=', ''))
    var img = document.createElement('IMG')
    img.src = url;
}
